export enum ScrollableSectionEnum {
  AboutUs = 'about-us',
  Insights = 'insights',
  ShiftSystem = 'shift-system',
  OpeningHours = 'opening-hours',
  Profile = 'profile',
  Responsibilities = 'responsibilities',
  Benefits = 'benefits',
  DailyWork = 'daily-work',
  Onboarding = 'onboarding',
  Gallery = 'gallery',
  Location = 'location',
  Salary = 'salary',
  Summary = 'summary',
  ClientAssignment = 'client-assignment',
  Highlights = 'highlights',
  Differentiations = 'differentiations',
  FrequencyOfTravel = 'frequency-of-travel',
  Career = 'career',
  ContactPerson = 'contact-person',
  EmployeeTestimony = 'employee-testimony',
}
